module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-74a72290cf6c5410080f8d561d7c565d.png";